import { gql } from "lib/apolloClient";

export const uiElementFragments = {
  uiElementCard: gql`
    fragment uiElementCard on UIElementCard {
      key
      isEnabled
      metadata
    }
  `,
};
